import styled from "styled-components";

type HeaderProps = {
	isFixed: boolean;
};

export const StyledHolder = styled.div<HeaderProps>`
	width: 100%;
	height: 70px;

	transition: 0.5s;

	display: ${(props) => (!props.isFixed ? "block" : "none")};

	@media (max-width: 600px) {
		height: 140px;
	}
`;

export const StyledHeader = styled.div<HeaderProps>`
	position: ${(props) => (props.isFixed ? "relative" : "fixed")};
	transform: ${(props) => (props.isFixed ? "" : "translateX(-50%)")};
	left: ${(props) => (props.isFixed ? "" : "50%")};
	top: 0;
	width: 100%;
	z-index: 1001;
	color: black;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	gap: 10px;

	.container {
		width: 100%;
		background: var(--green50);

		transition: 0.5s;
		-webkit-box-shadow: ${(props) =>
			props.isFixed ? "" : "0px 5px 22px -6px rgba(0, 0, 0, 0.75)"};
		-moz-box-shadow: ${(props) =>
			props.isFixed ? "" : "0px 5px 22px -6px rgba(0, 0, 0, 0.75)"};
		box-shadow: ${(props) =>
			props.isFixed ? "" : "0px 5px 22px -6px rgba(0, 0, 0, 0.75)"};
	}

	.container_box {
		max-width: 1250px;
		margin: 0 auto;
		display: flex;
		width: 100%;
		justify-content: space-between;
	}

	section {
		display: flex;
		gap: 10px;
	}

	@media (max-width: 600px) {
		max-width: 100vw;
		gap: 20px;
		flex-direction: column;

		.container_box {
			flex-direction: column;
			width: 100%;
			padding-bottom: 10px;
		}

		section {
			width: 100%;
			justify-content: space-between;
			gap: 0;
			padding: 10px 0 0 5px;
		}

		div {
			display: flex;

			p {
				font-weight: bold;

				span {
					display: none;
				}
			}
		}
	}
`;

type DivProps = {
	dontScale?: boolean
}

export const StyledDiv = styled.div<DivProps>`
	user-select: none;
	width: 75px;
	color: var(--blue50);
	cursor: pointer;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	position: relative;
	gap: 5px;
	color: var(--orange);
	-webkit-filter: drop-shadow(1px 1px 0 black) drop-shadow(-1px -1px 0 black);
	filter: drop-shadow(1px 1px 0 black) drop-shadow(-1px -1px 0 black);
	transition: 0.5s;
	font-weight: bold;

	svg {
		transition: 0.5s;
	}

	p {
		transition: 0.5s;
		text-transform: capitalize;
	}

	&:hover {
		color: ${(props) => props.dontScale ? "" : props.color};
		svg {
			transform: ${props => props.dontScale ? '' : 'scaleX(-1)'};
		}
	}

	@media (max-width: 600px) {
		gap: 2px;
	}
`;
